import { render, staticRenderFns } from "./CriarIpu.vue?vue&type=template&id=f79de1d6&scoped=true"
import script from "./CriarIpu.vue?vue&type=script&lang=js"
export * from "./CriarIpu.vue?vue&type=script&lang=js"
import style0 from "./CriarIpu.vue?vue&type=style&index=0&id=f79de1d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f79de1d6",
  null
  
)

export default component.exports